<script lang="ts">
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import { cn } from '$lib/utils';

  import type { MetricsByVariantStoryblok, MetricsStoryblok } from '$types/bloks';

  let className: string | undefined = undefined;
  export { className as class };
  export let block: MetricsStoryblok | MetricsByVariantStoryblok;
</script>

<div class={cn('rich-text-metrics text-sm', className)} use:storyblokEditable={block}>
  {#if block.title}
    <p class="mb-2 text-primary/40">{block.title}</p>
  {/if}
  <ul
    class={cn('flex flex-col gap-2', block.variant === 'tight' && 'border-y border-primary/4 py-2')}
  >
    {#each block.items as metric}
      <li
        class={cn(
          'flex items-center justify-between pb-0',
          !block.title && block.variant !== 'tight' && 'last:border-none last:pb-0',
          block.items.length > 1 && block.variant !== 'tight' && 'border-b border-primary/4 pb-2',
          block.variant === 'tight' && 'pb-0'
        )}
      >
        <span>
          {metric.name}
        </span>
        <span>
          {metric.value}
        </span>
      </li>
    {/each}
  </ul>
</div>
